const Underline = ({ ...props }) => {
  return (
    <svg
      width="187"
      height="15"
      viewBox="0 0 187 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.11784 8.72578C6.55599 8.72578 9.93713 9.65714 13.3647 9.95783C28.8857 11.3194 43.9369 8.36564 59.2584 5.43077C70.7579 3.22802 82.2614 2.07365 93.8702 2.02115C102.213 1.98341 110.122 1.74837 118.256 4.48524C129.061 8.12101 140.178 8.21004 151.232 8.21004C156.176 8.21004 160.894 8.50063 165.785 9.4994C169.184 10.1936 172.715 10.7888 176.156 10.7888C177.846 10.7888 179.537 10.7888 181.228 10.7888C182.214 10.7888 183.201 10.7888 184.188 10.7888C185.241 10.7888 185.234 10.5055 184.374 11.0466C181.212 13.0359 177.212 12.336 173.858 12.336C166.406 12.336 158.954 12.336 151.501 12.336C147.244 12.336 143.165 11.6075 138.936 11.0753C133.433 10.3829 127.812 10.7888 122.292 10.7888C114.858 10.7888 107.432 11.5856 99.9976 11.1899C93.5158 10.8448 87.1171 9.75727 80.6217 9.75727C75.2523 9.75727 70.3166 11.1154 65.034 12.2787C60.7841 13.2145 56.2502 13.0519 51.951 12.8231C48.9569 12.6637 45.9417 11.5884 42.9669 11.0466C40.1598 10.5354 37.2649 10.7888 34.4382 10.7888C32.0549 10.7888 29.2323 10.7173 26.9652 9.64266C25.08 8.74907 23.395 7.6943 21.376 7.6943C18.3404 7.6943 15.5477 7.66712 12.6195 6.4336C10.7767 5.65731 8.79579 5.60993 6.92679 4.71446C5.6996 4.12649 2.49656 3.39575 2 2.02115"
        stroke="#34A853"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Underline;
